import { useState, useCallback } from 'react';
import axios from 'axios';
import { ErrorPage } from '../ErrorPage';
import { isMobile } from '../../utils/utils';
import { DesktopFaceRecognition } from '../DesktopFaceRecognition';
import { useThemeContext } from '../../contexts/ThemeContext';
import { getOrCreateBrowserKey } from '../../utils/fingerprint_utils';
import { WebFaceReconSDK } from '../../sdks/WebFaceReconSDK';

export const FaceRecognition = (props) => {
    const { clientThemeSettings } = useThemeContext();
    const {
        signData,
        setSignerStep,
        setSignData,
        signerHash,
    } = props;

    const [error, setError] = useState({ has_error: false, status: 0 });

    const getClientSessionKey = useCallback(async () => {
        if (!signData.signer_token) {
            setError({ has_error: true, status: 401 });
            return null;
        }
        try {
            const config = { headers: { Authorization: signData.signer_token } };
            const response = await axios.get('signer/liveness_client_session_key', config);
            const clientSessionKey = response.data.client_session_key;

            if (!clientSessionKey) {
                throw new Error("No 'client_session_key' found.");
            }

            return clientSessionKey;

        } catch (err) {
            const status = err.response?.status;
            setError({ has_error: true, status: [401, 403, 409].includes(status) ? status : 500 });
            return null;
        }
    }, [signData.signer_token]);

    const handleSuccess = useCallback(async (imageKey) => {
        let browserKey = null;
        try {
            browserKey = await getOrCreateBrowserKey();
        } catch (err) {
        }
        const payload = { event_date: new Date().toISOString(), image_key: imageKey, step: 'face_recognition', device_data: { device_key: browserKey } };
        const config = { headers: { Authorization: signData.signer_token } };

        axios.patch('/signer', payload, config)
            .then(response => {
                setSignData({ ...signData, ...response.data });
                setSignerStep(response.data.next_step);
            })
            .catch(err => {
                const status = err.response?.status;
                setError({ has_error: true, status: [401, 403, 409].includes(status) ? status : 500 });
            });
    }, [signData, setSignData, setSignerStep]);

    if (!isMobile()) {
        return (
            <DesktopFaceRecognition {...props} clientThemeSettings={clientThemeSettings} loading={false} />
        );
    }

    return (
        <>
            <WebFaceReconSDK
                sessionId={signerHash}
                clientThemeSettings={clientThemeSettings}
                showBackButton={signData.signature_settings?.document_display_before_face_recognition !== false}
                getToken={getClientSessionKey}
                onSuccess={handleSuccess}
                onUserCanceled={() => setSignerStep('document_display')}
                onError={(status) => setError({ has_error: true, status })}
            />
            {error.has_error && (
                <ErrorPage
                    error={error}
                    redirectToLogin={() => setSignerStep('login')}
                    resetError={() => setError({ has_error: false, status: 0 })}
                    clientThemeSettings={clientThemeSettings}
                />
            )}
        </>
    );
};
